import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { FormsUtilsService, MessageService, notCloseMessageOptions } from '../../../../../core';
import { Cep } from '../../../../../core/services/cep';
import { CollapseGroupComponent } from '../../../../../shared';
import { PessoaEnderecoCidadeComponent, isEnderecoTipoCobranca, isEnderecoTipoEntrega, isEnderecoTipoPrincipal } from '../../../../pessoa/endereco';
import { LeadEndereco, } from '../lead-endereco';

@Component({
    selector: 'sgt-lead-endereco-unico',
    templateUrl: './lead-endereco-unico.component.html',
    styleUrls: ['./lead-endereco-unico.component.less']
})
export class LeadEnderecoUnicoComponent implements OnChanges {
    /** Se pode editar os dados do form do endereço do lead */
    @Input() canEdit = true;
    @Input() tipoEndereco: number;
    @Input() entity: LeadEndereco;
    @Output() entityChange = new EventEmitter<LeadEndereco>();
    @Input() idRepresentante: number;
    @Input() permiteExcluir = true;

    // Endereço
    @Input() cepRequired = false; // Se o CEP deve ser obrigatório
    @Input() logradouroRequired = false; // Se o logradouro deve ser obrigatório
    @Input() bairroRequired = false; // Se o bairro deve ser obrigatório
    @Input() inscricaoEstadualRequired = false;
    @Input() exibirInscricaoSuframa = true;
    @Input() exibirInscricaoProdutorRural = true;
    @Input() exterior = false; // Se for um endereço de um lead do exterior
    /** Input se possui ou não Inscrição Suframa */
    @ViewChild('possuiInscricaoSuframaInput') possuiInscricaoSuframaInput: ElementRef;
    /** Input da Inscrição Suframa */
    @ViewChild('enderecoInscSuframaInput') enderecoInscSuframaInput: ElementRef;

    /** Se o form deve ser exibido em tamanho pequeno */
    @Input() isMini = false;

    @ViewChild('form') form: NgForm;
    @ViewChild('formCidade') formCidade: PessoaEnderecoCidadeComponent;

    constructor(private formsUtilsService: FormsUtilsService,
                private messageService: MessageService) { }


    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            // Quando existir o endereço
            if (propName === 'entity') {
                if (changes[propName].isFirstChange()) {
                    if (this.entity) {
                        // Setando a UF da máscara da IE
                        // if (this.entity.cidade) {
                        //     this.ufMascaraIe = this.entity.cidade.estado.uf;
                        // }
                    }
                }
            }
        }
    }

    /** Verifica se é o Endereço Principal */
    isEnderecoPrincipal(): boolean {
        return isEnderecoTipoPrincipal(this.tipoEndereco);
    }

    /** Verifica se é o Endereço de Cobrança */
    isEnderecoCobranca(): boolean {
        return isEnderecoTipoCobranca(this.tipoEndereco);
    }

    /** Verifica se é o Endereço de Entrega */
    isEnderecoEntrega(): boolean {
        return isEnderecoTipoEntrega(this.tipoEndereco);
    }

   /** Verifica se pode adicionar o endereço quando o mesmo não estiver cadastrado */
   canInsert(): boolean {
        // Se não puder editar, então não pode adicionar o endereço
        if (!this.canEdit) {
            return false;
        }

        return true;
    }

    /** Verifica se pode excluir o endereço */
    canDelete(): boolean {
        // Se não puder editar, então não pode excluir o endereço
        if (!this.canEdit) {
            return false;
        }

        return this.permiteExcluir;
    }

    /** Verifica se pode salvar o endereço quando o mesmo não estiver cadastrado */
    canSave(): boolean {
        // Se não puder editar, então não pode salvar o endereço
        if (!this.canEdit) {
            return false;
        }

        return true;
    }

    /** Quando o CEP for encontrado, setamos os valores nos campos do endereço */
    onCepEncontrado(cep: Cep) {
        if (cep) {
            this.entity.logradouro = cep.logradouro;
            this.entity.bairro = cep.bairro;
            this.entity.complemento = cep.complemento;
            this.formCidade?.setDadosCep(cep);
            // this.ufMascaraIe = cep.cidade.estado.uf;
        }
    }


    insert() {
        this.entity = new LeadEndereco(this.tipoEndereco);
        this.entityChange.emit(this.entity);
        this.formCidade?.insert();
    }

    /** Seta o pais e cidade conforme se for um endereço de exterior ou não */
    setCidadeEPais() {
        this.formCidade?.insert();
    }

    /** Carrega as sub-regiões da cidade informada e representante */
    carregarSubRegioesDaCidade() {
        this.formCidade?.carregarSubRegioes();
    }

    /** Carrega os bairros da sub-região informada */
    carregarBairrosDaSubRegiaoDaCidade() {
        this.formCidade?.carregarBairrosDaSubRegiao();
    }

    delete() {
        this.messageService.confirm('Deseja realmente excluir este endereço?', 'Confirme').then(result => {
            if (result) {
                this.entity = null;
                this.entityChange.emit(null);
            }
        });
    }

     /** Verifica se o endereço único está válido */
    isValid(): boolean {
        // Se não puder salvar então retoramos como form válido para não dar erros de campos inválidos
        if (!this.canSave()) {
            return true;
        }

        if (this.entity) {
            // Inscrição Suframa
            if (this.exibirInscricaoSuframa) {
                // Flag se possui ou não inscrição não selecionada
                if (this.entity.possuiInscricaoSuframa == null || this.entity.possuiInscricaoSuframa === undefined) {
                    this.messageService.warning('Selecione se este lead possui ou não inscrição Suframa', 'Atenção', notCloseMessageOptions);
                    setTimeout(() => jQuery(this.possuiInscricaoSuframaInput.nativeElement).trigger('focus'), 300);
                    return false;
                }
                // Lead possui inscrição mas inscrição não informada
                if (this.entity.possuiInscricaoSuframa && (!this.entity.inscricaoSuframa || this.entity.inscricaoSuframa.trim().length === 0)) {
                    this.messageService.warning('Lead selecionado que possui inscrição Suframa mas inscrição não informada. Informe a Inscrição Suframa e tente novamente', 'Atenção', notCloseMessageOptions);
                    setTimeout(() => jQuery(this.enderecoInscSuframaInput.nativeElement).trigger('focus'), 300);
                    return false;
                }
            }
        }

        // Se o formulário do endereço ou da cidade não estiverem válidos, retornamos que o endereço não está válido
        this.formsUtilsService.makeAllFieldsDirty(this.form);
        if (!this.form.valid || (this.formCidade && !this.formCidade.isValid())) {
            this.messageService.info('Para salvar é preciso informar corretamente o endereço e todos os seus campos destacados em vermelho', 'Informação');
            return false;
        }

        return true;
    }
}
